import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { resetYesNoDialog } from './state/actions';
import { getYesNoDialogProps } from './state/selectors';
import { YesNoDialog } from './YesNoDialog';

class DialogManager extends React.Component {
  static displayName = 'YesNoDialogManager';

  static propTypes = {
    resetYesNoDialog: PropTypes.func,
    yesNoDialogProps: PropTypes.shape({
      showDialog: PropTypes.bool.isRequired,
      title: PropTypes.string,
      question: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.func,
        PropTypes.node,
      ]),
      yesCallback: PropTypes.func,
      noCallback: PropTypes.func,
      cancelCallback: PropTypes.func,
    }),
  };

  render() {
    const { resetYesNoDialog } = this.props;
    const {
      yesCallback,
      noCallback,
      cancelCallback,
      ...rest
    } = this.props.yesNoDialogProps;

    return (
      <YesNoDialog
        {...rest}
        yesCallback={() => {
          yesCallback();
          resetYesNoDialog();
        }}
        noCallback={() => {
          noCallback();
          resetYesNoDialog();
        }}
        cancelCallback={() => {
          cancelCallback();
          resetYesNoDialog();
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  yesNoDialogProps: getYesNoDialogProps(state),
});

const mapDispatchToProps = {
  resetYesNoDialog,
};

export const YesNoDialogManager = connect(
  mapStateToProps,
  mapDispatchToProps
)(DialogManager);



// WEBPACK FOOTER //
// ./src/components/dialogs/YesNoDialogManager.js